export const locationNameMap: Record<string, string> = {
  "arvada": "Arvada",
  "aurora": "Aurora",
  "capitol-hill": "Capitol Hill",
  "centennial": "Centennial",
  "central-park": "Central Park",
  "cherry-creek": "Cherry Creek",
  "cherry-hills": "Cherry Hills Village",
  "columbine": "Columbine",
  "commerce-city": "Commerce City",
  "denver": "Denver",
  "dtc": "Denver Tech Center",
  "edgewater": "Edgewater",
  "englewood": "Englewood",
  "glendale": "Glendale",
  "golden": "Golden",
  "greenwood-village": "Greenwood Village",
  "highlands": "Highlands",
  "highlands-ranch": "Highlands Ranch",
  "ken-caryl": "Ken Caryl",
  "lakewood": "Lakewood",
  "littleton": "Littleton",
  "rino": "RiNo Arts District",
  "wash-park": "Washington Park",
  "wheat-ridge": "Wheat Ridge"
};

export const serviceNameMap: Record<string, string> = {
  "dog-grooming": "Dog Grooming",
  "full-groom": "Full Groom",
  "cat-grooming": "Cat Grooming",
  "spa": "Luxury Spa Bath",
  "puppy-cut": "Puppy Grooming",
  "senior-care": "Senior Pet Grooming",
  "deshedding": "Deshedding Treatment",
  "nail-trim": "Nail Trim"
};
